export default [
  {
    path: '/log-off',
    name: 'logOff',
    component: () => import('../../pages/userCenter/logoff.vue'),
    meta: {
      title: '注销账号',
      authorization: true
    }
  },
  {
    path: '/log-off-code',
    name: 'logOffCode',
    component: () => import('../../pages/userCenter/verifyLogOffCode.vue'),
    meta: {
      title: ' ',
      authorization: true
    }
  },
  {
    path: '/log-off-success',
    name: 'logOffSuccess',
    component: () => import('../../pages/userCenter/logOffSuccess.vue'),
    meta: {
      title: ' ',
      authorization: true
    }
  }
];
